<template>
    <div>
        <div class="flex">
            <vs-checkbox
                v-if="selectedTax"
                size="large" 
                class="w-2/12" 
                :value="availableTaxes[selectedTax].enabled"
                @change="val => enableTax(selectedTax, val)"
                />

            <a-select size="large" :default-value="selectedTax" :value="selectedTax" class="combo primary w-10/12" dropdownClassName="combo" @select="val => selectedTax = val">
                <a-select-option :value="tax[0]" v-for="(tax, i) in Object.entries(this.availableTaxes)" :key="i" >
                    {{ $t(tax[0]) }}
                </a-select-option>
            </a-select>
        </div>
 
        <vs-input 
            :disabled="!availableTaxes[selectedTax].enabled"
            class="primary mt-2 w-full" 
            :placeholder="$t('taxExample')"
            v-model="availableTaxes[selectedTax].description" />

        <money
            v-if="selectedTax != 'percentage'"
            :disabled="!availableTaxes[selectedTax].enabled"
            class="mt-2 vs-inputx vs-input--input normal w-full"
            style="border: 1px solid rgba(0, 0, 0, 0.2);"
            v-model="availableTaxes[selectedTax].value" 
            v-bind="{
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            }">
        </money>

        <div class="vx-row" v-if="selectedTax == 'percentage'" >
            <div class="vx-col">
                <a-input-number 
                    :disabled="!availableTaxes[selectedTax].enabled"
                    v-model="availableTaxes[selectedTax].value" 
                    size="large"
                    :min="0" 
                    :max="100" 
                    class="mt-2"
                />
            </div>
            <div class="">
                <a-icon type="percentage" class="mt-5" style="font-size: 22px" />
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'

    export default {
        props : {
            initialTaxes : {
                type: Object,
                required : false
            }
        },

        components : {
            vSelect
        },

        data () {
            return {
                selectedTax : 'absolute',
                availableTaxes : {
                    absolute : {
                        description : '',
                        enabled : false,
                        value : 0,
                    },
                    byPerson : {
                        description : '',
                        enabled : false,
                        value : 0,
                    },
                    percentage : {
                        description : '',
                        enabled : false,
                        value : 1,
                    }
                }
            }
        },

        watch : {
            initialTaxes : {
                handler(val) {
                    if(Object.keys(this.initialTaxes).length > 0 )
                        this.availableTaxes = this.initialTaxes
                },
                deep : true
            },

            availableTaxes : {
                deep : true,
                handler (val) {
                    this.$emit('change', val)
                }
            }
        },

        mounted () {

            if(Object.keys(this.initialTaxes).length > 0 )
                this.availableTaxes = this.initialTaxes

            Object.entries(this.availableTaxes).forEach(tax => {
                if(tax[1].enabled){
                    this.selectedTax = tax[0]
                }
            })
        },

        methods : {
            enableTax (selectedTax, value) {
                this.$set(this.availableTaxes[selectedTax], 'enabled', value.target.checked)

                Object.entries(this.availableTaxes || []).forEach(tax => {
                    if(tax[0] != selectedTax)
                        if(value.target.checked == true){
                            this.$set(this.availableTaxes[tax[0]], 'enabled', false)
                        }
                })
            }
        }
    }
</script>

<style>
    .combo {
        z-index: 9999999
    }
</style>